import {
  colorNetNumericSettings,
  similarityNetNumericSettings,
} from "../constants";
import {
  CampaignType,
  Embedder,
  EmbedderItem,
  SiteItem,
} from "@vviinn/user-managment-client-ts";

import { filteredTextNets } from "../textSearch/filteredTextNets";
import { CampaignNetKey, RelevantNets } from "../types";
import { capitalize } from "../../helpers/string/capitalize";

const embedderNameToNet = (name: Embedder) =>
  `${name
    .split("_")
    .map((item, index) => (index === 0 ? item : capitalize(item)))
    .join("")}Weight` as CampaignNetKey;

const relevantNets = (
  embedders: EmbedderItem[],
  netsGroup: CampaignNetKey[],
) => {
  const availableNets = embedders.map(({ name }) => embedderNameToNet(name));
  return netsGroup.filter((net) =>
    availableNets.some((availableNet) => availableNet === net),
  );
};

export const relevantCampaignNets = (
  campaignType: CampaignType,
  siteDetails: SiteItem,
): RelevantNets => {
  const embedders = siteDetails?.embedders;
  if (!siteDetails || !embedders?.length)
    return {
      relevantSimilarities: [],
      relevantColors: [],
      relevantTextNets: [],
    };
  else if (campaignType === "TEXT_SEARCH")
    return { relevantTextNets: filteredTextNets(siteDetails) };
  else {
    const relevantSimilarities = relevantNets(
      embedders,
      similarityNetNumericSettings,
    );

    return {
      relevantSimilarities:
        campaignType === "VPS"
          ? relevantSimilarities.filter((net) => !net.startsWith("darjeeling"))
          : relevantSimilarities,
      relevantColors: relevantNets(embedders, colorNetNumericSettings),
    };
  }
};
